module.exports = __webpack_public_path__ + "static/media/how.73a1b19a.gif";